<template>
  <div class="orderInfoContainer" :class="{'orderInfoContainer--Mobile' : isScreenSmall}">   <!-- container-fluid class is needed for datalist dropdown to appear (This do be kinda weird doe) -->
    <!-- Pickup -->
    <div class="orderColumn" id="pickup" :class="{'mx-2' : !isScreenSmall}">
      <h4 class="text-center kne-title my-3">{{$t('OrderPending.pickupDeliveryTab.pickup')}}</h4>
      <regular-datalist
        class="mt-3 form-group"
        :value="datalist.pickup"
        @input="setAndSearch($event, 'pickup')"
        :originalList="$store.state.allContacts"
        :secondList="addressbook"
        :placeholder="$t('AddressBook.title')"/>

      <div>
        <vue-google-autocomplete
          ref="AutocompleteSearchPickup"
          class="form-control border my-3"
          id="orderTransmitter"
          :placeholder="$t('AddressBook.search_autocomplete')"
          v-on:placechanged="onVGA_TRMTRSearch"
          :country="['ca', 'us']"
          :fields="autocompleteSearchFields">
        </vue-google-autocomplete>

        <regular-select
          class="my-3"
          v-if="arrOfTransmitterPlaces.length > 0"
          :value="order.transmitterName"
          @change="onCompanyNameSelect($event, baseStr.transmitter); order.transmitterName = $event;"
          :placeholder="$t('NewOrder.multiple_select') + '*'">
          <option v-for="place in arrOfTransmitterPlaces" :key="place.name" :value="place.name">{{place.name}}</option>
        </regular-select>
        <regular-input
          id="trName"
          :value="order.transmitterName"
          @input="order.transmitterName = $event; onInputEntered()"
          type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.name') + '*'" class="form-group" :class="{'input--missing' : order.transmitterName === ''}"/>

        <regular-input
          id="trAddress"
          :value="order.transmitterAddress"
          @input="order.transmitterAddress = $event; onInputEntered()"
          :disabled="isTransmitterInfo.address"
          type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.address') + '*'" class="form-group" :class="{'input--missing' : order.transmitterAddress === ''}"/>
        <regular-input
          id="trCity"
          :value="order.transmitterCity"
          @input="order.transmitterCity = $event; onInputEntered()"
          :disabled="isTransmitterInfo.city"
          type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.city') + '*'" class="form-group" :class="{'input--missing' : order.transmitterCity === ''}"/>
        <regular-input
          id="trPostcode"
          :value="order.transmitterPostcode"
          @input="order.transmitterPostcode = $event; onInputEntered()"
          :disabled="isTransmitterInfo.postcode"
          type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.postal_code') + '*'" class="form-group" :class="{'input--missing' : order.transmitterPostcode === ''}"/>
        <regular-input
          id="trProvince"
          :value="order.transmitterProvince"
          @input="order.transmitterProvince = $event; onInputEntered()"
          :disabled="isTransmitterInfo.province"
          type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.province') + '*'" class="form-group" :class="{'input--missing' : order.transmitterProvince === ''}"/>
        <regular-input
          id="trCountry"
          :value="order.transmitterCountry"
          @input="order.transmitterCountry = $event; onInputEntered()"
          :disabled="isTransmitterInfo.country"
          type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.country') + '*'" class="form-group" :class="{'input--missing' : order.transmitterCountry === ''}"/>

        <label v-show="feedbackMessage && order.transmitterEmail" class="mt-0" for="transmitterEmail">
          {{feedbackMessage}}
          <hover-tool-tip
            class=""
            :text="$t('NewOrder.email_format_required')"
            top
            right
          />
        </label>
        <div class="flex-row" id="transmitterEmail">
          <regular-input
            :value="order.transmitterEmail"
            @input="order.transmitterEmail = $event"
            type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.add_email')" class="w-100"
            @keyup.enter.native="onEmailAdd(order.transmitterEmail, baseStr.transmitter)"
          />
            <hover-tool-tip
              class="mx-2"
              :text="$t('NewOrder.email_tooltip')"
              top
              right
            />
            <button class="btn btn-kne-green ml-2" @click="onEmailAdd(order.transmitterEmail, baseStr.transmitter)"><i class="fa fa-solid fa-plus"></i></button>
        </div>

        <div class="flex-row my-1" v-for="(email, index) in order.transmitterEmailList" :key="index">
          <i class="w-100 m-1 mt-2">{{email}}</i>
          <hr class="hrLine w-100 mx-3">
          <label class="custom-control custom-checkbox my-2 ml-2 mr-0">
            <input :value="email" v-model="selectedEmails" type="checkbox" @change="onEmailSelected(selectedEmails)" class="custom-control-input">
            <span class="custom-control-indicator"></span>
          </label>
          <button class="btn btn-kne-red py-1" @click="onEmailRemove(index, baseStr.transmitter)">X</button>
        </div>

        <regular-input
          :value="order.transmitterPhone"
          @input="order.transmitterPhone = $event"
          type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.phone')" class="form-group mt-3"/>
        <regular-input
          :value="order.transmitterFax"
          @input="order.transmitterFax = $event"
          type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.fax')" class="form-group"/>
        <regular-input
          :value="order.transmitterContact"
          @input="order.transmitterContact = $event"
          type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.contact')" class="form-group mb-0"/>
        <regular-checkbox
          :checked="pickupSave"
          @change="pickupSave = $event"
          :label="$t('OrderPending.pickupDeliveryTab.save_dealer')"/>
      </div>
    </div>

    <!-- Delivery -->
    <div class="orderColumn" :class="{'mx-2' : !isScreenSmall}" id="delivery">
      <h4 class="text-center kne-title my-3">{{$t('OrderPending.pickupDeliveryTab.delivery')}}</h4>
      <regular-datalist
        :value="datalist.delivery"
        @input="setAndSearch($event, 'delivery')"
        :originalList="$store.state.allContacts"
        :secondList="addressbook"
        :placeholder="$t('AddressBook.title')" class="form-group"/>
      <div>
        <vue-google-autocomplete
          class="form-control border my-3"
          id="orderReceiver"
          ref="AutocompleteSearchDelivery"
          :placeholder="$t('AddressBook.search_autocomplete')"
          v-on:placechanged="onVGA_RCVRSearch"
          :country="['ca', 'us']"
          :fields="autocompleteSearchFields">
        </vue-google-autocomplete>

        <regular-select
          class="my-3"
          v-if="arrOfReceiverPlaces.length > 0"
          :value="order.receiverName"
          @change="onCompanyNameSelect($event, baseStr.receiver); order.receiverName = $event;"
          :placeholder="$t('NewOrder.multiple_select') + '*'">
          <option v-for="place in arrOfReceiverPlaces" :key="place.name" :value="place.name">{{place.name}}</option>
        </regular-select>

        <regular-input
          id="reName"
          :value="order.receiverName"
          @input="order.receiverName = $event; onInputBillingSame(); onInputEntered()"
          type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.name') + '*'" class="form-group" :class="{'input--missing' : order.receiverName === ''}"/>
        <regular-input
          id="reAddress"
          :value="order.receiverAddress"
          @input="order.receiverAddress = $event; onInputBillingSame(); onInputEntered()"
          :disabled="isReceiverInfo.address"
          type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.address') + '*'" class="form-group" :class="{'input--missing' : order.receiverAddress === ''}"/>
        <regular-input
          id="reCity"
          :value="order.receiverCity"
          @input="order.receiverCity = $event; onInputBillingSame(); onInputEntered()"
          :disabled="isReceiverInfo.city"
          type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.city') + '*'" class="form-group" :class="{'input--missing' : order.receiverCity === ''}"/>
        <regular-input
          id="rePostcode"
          :value="order.receiverPostcode"
          @input="order.receiverPostcode = $event; onInputBillingSame(); onInputEntered()"
          :disabled="isReceiverInfo.postcode"
          type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.postal_code') + '*'" class="form-group" :class="{'input--missing' : order.receiverPostcode === ''}"/>
        <regular-input
          id="reProvince"
          :value="order.receiverProvince"
          @input="order.receiverProvince = $event; onInputBillingSame(); onInputEntered()"
          :disabled="isReceiverInfo.province"
          type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.province') + '*'" class="form-group" :class="{'input--missing' : order.receiverProvince === ''}"/>
        <regular-input
          id="reCountry"
          :value="order.receiverCountry"
          @input="order.receiverCountry = $event; onInputBillingSame(); onInputEntered()"
          :disabled="isReceiverInfo.country"
          type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.country') + '*'" class="form-group" :class="{'input--missing' : order.receiverCountry === ''}"/>

        <!-- <label v-show="feedbackMessage && order.receiverEmail" class="mt-0" for="receiverEmail">{{feedbackMessage}}
          <hover-tool-tip
            class="mx-2"
            :text="$t('NewOrder.email_format_required')"
            top
            right
          />
        </label>
        <div class="flex-row" id="receiverEmail">
          <regular-input
            :value="order.receiverEmail"
            @input="order.receiverEmail = $event; onInputBillingSame()"
            type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.email')" class="w-100"
            @keyup.enter.native="onEmailAdd(order.receiverEmail, baseStr.receiver)"
          />
          <hover-tool-tip
            class="mx-2"
            :text="$t('NewOrder.email_tooltip')"
            top
            left
          />
          <button class="btn btn-kne-orange ml-1" @click="onEmailAdd(order.receiverEmail, baseStr.receiver)">+</button>
        </div>

        <div class="flex-row my-1" v-for="(email, index) in order.receiverEmailList" :key="index">
          <i class="w-100 m-1">{{email}}</i>
          <hr class="hrLine w-100 mx-3">
          <label class="custom-control custom-checkbox my-2 ml-2 mr-0">
            <input :value="email" v-model="selectedEmails" @change="onEmailSelected(selectedEmails)" type="checkbox" class="custom-control-input">
            <span class="custom-control-indicator"></span>
          </label>
          <button class="btn btn-kne-red py-1" @click="onEmailRemove(index, baseStr.receiver)">X</button>
        </div> -->

        <regular-input
          :value="order.receiverPhone"
          @input="order.receiverPhone = $event; onInputBillingSame()"
          type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.phone')" class="form-group mt-3"/>
        <regular-input
          :value="order.receiverFax"
          @input="order.receiverFax = $event; onInputBillingSame()"
          type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.fax')" class="form-group"/>
        <regular-input
          :value="order.receiverContact"
          @input="order.receiverContact = $event; onInputBillingSame()"
          type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.contact')" class="form-group mb-0"/>
        <regular-checkbox
          :checked="deliverySave"
          @change="deliverySave = $event"
          :label="$t('OrderPending.pickupDeliveryTab.save_dealer')" class=""/>
      </div>
    </div>

    <!-- Billing -->
    <div class="orderColumn" :class="{'mx-2' : !isScreenSmall}" id="billing" v-show="showBilling">
      <h4 class="text-center kne-title my-3">{{$t('OrderPending.pickupDeliveryTab.billing')}}</h4>
      <regular-datalist
      :value="datalist.billing"
      @input="setAndSearch($event, 'billing')"
      :disabled="billingSame"
      :originalList="$store.state.allContacts"
      :secondList="isSageOne ? sageIDonly : addressbook"
      :placeholder="$t('AddressBook.title')" class="form-group"/>
      <br style="margin-top: 1.9rem;">

      <regular-input
        :value="order.payerName"
        @input="order.payerName = $event"
        :disabled="billingSame"
        type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.name') + '*'" class="form-group" :class="{'input--missing' : order.payerName === ''}"/>
      <regular-input
        :value="order.payerAddress"
        @input="order.payerAddress = $event"
        :disabled="billingSame"
        type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.address') + '*'" class="form-group" :class="{'input--missing' : order.payerAddress === ''}"/>
      <regular-input
        :value="order.payerCity"
        @input="order.payerCity = $event"
        :disabled="billingSame"
        type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.city') + '*'" class="form-group" :class="{'input--missing' : order.payerCity === ''}"/>
      <regular-input
        :value="order.payerPostcode"
        @input="order.payerPostcode = $event"
        :disabled="billingSame"
        type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.postal_code') + '*'" class="form-group" :class="{'input--missing' : order.payerPostcode === ''}"/>
      <regular-input
        :value="order.payerProvince"
        @input="order.payerProvince = $event"
        :disabled="billingSame"
        type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.province') + '*'" class="form-group" :class="{'input--missing' : order.payerProvince === ''}"/>
      <regular-input
        :value="order.payerCountry"
        @input="order.payerCountry = $event"
        :disabled="billingSame"
        type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.country') + '*'" class="form-group" :class="{'input--missing' : order.payerCountry === ''}"/>
      <regular-input
        :value="order.payerEmail"
        @input="order.payerEmail = $event"
        type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.email')" class="form-group"/>
      <regular-input
        :value="order.payerPhone"
        @input="order.payerPhone = $event"
        :disabled="billingSame"
        type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.phone')" class="form-group"/>
      <regular-input
        :value="order.payerFax"
        @input="order.payerFax = $event"
        :disabled="billingSame"
        type="tel" :placeholder="$t('OrderPending.pickupDeliveryTab.fax')" class="form-group"/>
      <regular-input
        :value="order.payerContact"
        @input="order.payerContact = $event"
        :disabled="billingSame"
        type="text" :placeholder="$t('OrderPending.pickupDeliveryTab.contact')" class="form-group"/>
      <regular-checkbox
        :checked="billingSame"
        @change="billingSame = $event"
        :label="$t('OrderPending.pickupDeliveryTab.same_as_delivery')" class=""/>
    </div>

  </div>
</template>

<script>
import HoverToolTip from '../../basic-components/HoverToolTip.vue'
import regularInput from '../../basic-components/regularInput.vue'
import regularCheckbox from '../../basic-components/regularCheckbox.vue'
import regularTextarea from '../../basic-components/regularTextarea.vue'
import regularSelect from '../../basic-components/regularSelect.vue'
import regularInputNumber from '../../basic-components/regularInputNumber.vue'
import { BasicSelect } from 'vue-search-select'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import {db} from '../../../../firebase'
import _ from 'lodash'

export default {
  components: {
    HoverToolTip,
    regularInput,
    regularCheckbox,
    regularTextarea,
    regularSelect,
    regularInputNumber,
    VueGoogleAutocomplete,
    BasicSelect
  },

  props: {
    order: Object,
    originalList: Object,
    addressbook: Array,
    showBilling: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      pickupSave: false,
      arrOfTransmitterPlaces: [],
      isTransmitterInfo: {
        address: true,
        postcode: true,
        city: true,
        province: true,
        country: true
      },

      deliverySave: false,
      arrOfReceiverPlaces: [],
      isReceiverInfo: {
        address: true,
        postcode: true,
        city: true,
        province: true,
        country: true
      },

      billingSame: false,
      datalist: {
        pickup: '',
        pickupUid: '',
        delivery: '',
        deliveryUid: '',
        billing: '',
        billingUid: ''
      },

      selectedEmails: [],
      feedbackMessage: '',
      baseStr: {
        transmitter: 'Transmitter',
        receiver: 'Receiver'
      },
      backup: {
        sageIDDelivery: ''
      },
      autocompleteSearchFields: ['address_components', 'adr_address', 'formatted_address', 'formatted_phone_number', 'geometry', 'id', 'name', 'place_id', 'type', 'vicinity']
      // 'utc_offset_minutes', 'url', 'photo', 'business_status', 'icon', 'scope', 'alt_id',
    }
  },

  created () {
    this.$bindAsArray('liste', db.ref('database/transporter/' + this.companyUID + '/liste'))
  },

  methods: {
    onInputEntered: _.debounce(function () {
      this.$emit('onVGAInput')
    }, 500),

    /** When email is checked/selected */
    onEmailSelected (selectedEmails) {
      this.$emit('sendSelectedEmails', selectedEmails)
    },

    /** When email is added to an email list
     * @var locFieldType: String indicating if the function call comes from transmitter or receiver
     */
    onEmailAdd (email) {
      if (!email) return
      if (!this.validateEmail(email)) {
        this.feedbackMessage = this.$t('NewOrder.email_invalid_format')
        return
      }

      this.feedbackMessage = ''
      if (typeof this.order.transmitterEmailList === 'undefined' || this.order.transmitterEmailList === '') this.order.transmitterEmailList = []
      this.order.transmitterEmailList.push(email)
      this.order.transmitterEmail = ''
    },

    /** Regex of javascript email
     * @link https://www.emailregex.com/ */
    validateEmail (email) {
      if (email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) return true
      else return false
    },

    /** When email is removed from an email list */
    onEmailRemove (index) {
      this.order.transmitterEmailList.splice(index, 1)
      this.$forceUpdate()
    },

    // TRANSMITTER TRANSMITTER TRANSMITTER TRANSMITTER TRANSMITTER TRANSMITTER TRANSMITTER
    /** On searching an address with Vue-Google-Autocomplete */
    async onVGA_TRMTRSearch (addressData, placeResultData) {
      this.clearTransmitterInfo() // Clean plate for search

      const nameOfThisPlace = placeResultData.name
      let nameUsed = ''
      if (!nameOfThisPlace.includes(placeResultData.formatted_address.split(',')[0])) {
        nameUsed = placeResultData.name
      }

      this.order.transmitterName = nameUsed || ''
      this.order.transmitterAddress = placeResultData.formatted_address.split(',')[0] || ''
      this.order.transmitterPostcode = addressData.postal_code || ''
      this.order.transmitterPhone = placeResultData.formatted_phone_number || ''
      this.order.transmitterCity = addressData.locality || ''
      this.order.transmitterProvince = addressData.administrative_area_level_1 || ''
      this.order.transmitterCountry = addressData.country || ''
      this.order.transmitterPlaceId = placeResultData.place_id || ''
      this.order.transmitterLat = addressData.latitude || ''
      this.order.transmitterLong = addressData.longitude || ''

      this.checkVGATransmitterInfo()
      let addressBook = await this.getAddressbook(placeResultData.place_id)
      this.arrOfTransmitterPlaces = this.getCommonPlaces(addressBook, placeResultData.place_id)
    },

    /** Clear transmitter related data before The Big Bang */
    clearTransmitterInfo () {
      this.datalist.pickup = ''
      this.datalist.pickupUid = ''
      this.order.transmitterName = ''
      this.order.transmitterAddress = ''
      this.order.transmitterPostcode = ''
      this.order.transmitterPhone = ''
      this.order.transmitterFax = ''
      this.order.transmitterContact = ''
      this.order.transmitterCity = ''
      this.order.transmitterProvince = ''
      this.order.transmitterCountry = ''
      this.order.transmitterPlaceId = ''
      this.order.transmitterLat = 0
      this.order.transmitterLong = 0
      this.order.transmitterEmailList = []
    },

    /** Sometimes VGA addresses have missing data.
     * This is to allow users to fill in info themselves if there are missing info.
     */
    checkVGATransmitterInfo () {
      if (this.order.transmitterAddress !== '') this.isTransmitterInfo.address = true
      else this.isTransmitterInfo.address = false

      if (this.order.transmitterPostcode !== '') this.isTransmitterInfo.postcode = true
      else this.isTransmitterInfo.postcode = false

      if (this.order.transmitterCity !== '') this.isTransmitterInfo.city = true
      else this.isTransmitterInfo.city = false

      if (this.order.transmitterProvince !== '') this.isTransmitterInfo.province = true
      else this.isTransmitterInfo.province = false

      if (this.order.transmitterCountry !== '') this.isTransmitterInfo.country = true
      else this.isTransmitterInfo.country = false
    },

    /** Set the transmitter info from the @company that is given */
    setTransmitterInfo (company) {
      if (company.emailList) this.order.transmitterEmailList = company.emailList
      else this.order.transmitterEmailList = []

      this.order.transmitterName = company.name
      this.order.transmitterAddress = company.address
      this.order.transmitterPostcode = company.postcode
      this.order.transmitterCity = company.city
      this.order.transmitterProvince = company.province
      this.order.transmitterCountry = company.country
      this.order.transmitterPhone = company.phone
      this.order.transmitterFax = company.fax
      this.order.transmitterContact = company.contact
      this.order.transmitterPlaceId = company.placeId !== undefined ? company.placeId : this.order.transmitterPlaceId
      this.order.transmitterLat = company.lat !== undefined ? company.lat : this.order.transmitterLat
      this.order.transmitterLong = company.long !== undefined ? company.long : this.order.transmitterLong
    },

    // RECEIVER RECEIVER RECEIVER RECEIVER RECEIVER
    async onVGA_RCVRSearch (addressData, placeResultData) {
      this.clearReceiverInfo()

      const nameOfThisPlace = placeResultData.name
      let nameUsed = ''
      if (!nameOfThisPlace.includes(placeResultData.formatted_address.split(',')[0])) {
        nameUsed = placeResultData.name
      }

      this.order.receiverName = nameUsed || ''
      this.order.receiverAddress = placeResultData.formatted_address.split(',')[0] || ''
      this.order.receiverPostcode = addressData.postal_code || ''
      this.order.receiverPhone = placeResultData.formatted_phone_number || ''
      this.order.receiverCity = addressData.locality || ''
      this.order.receiverProvince = addressData.administrative_area_level_1 || ''
      this.order.receiverCountry = addressData.country || ''
      this.order.receiverPlaceId = placeResultData.place_id || ''
      this.order.receiverLat = addressData.latitude || ''
      this.order.receiverLong = addressData.longitude || ''

      this.checkVGAReceiverInfo()
      let addressBook = await this.getAddressbook(placeResultData.place_id)
      this.arrOfReceiverPlaces = this.getCommonPlaces(addressBook, placeResultData.place_id)
    },

    clearReceiverInfo () {
      this.datalist.delivery = ''
      this.datalist.deliveryUid = ''
      this.order.receiverName = ''
      this.order.receiverAddress = ''
      this.order.receiverPostcode = ''
      this.order.receiverPhone = ''
      this.order.receiverFax = ''
      this.order.receiverContact = ''
      this.order.receiverCity = ''
      this.order.receiverProvince = ''
      this.order.receiverCountry = ''
      this.order.receiverPlaceId = ''
      this.order.receiverLat = 0
      this.order.receiverLong = 0
      this.order.receiverEmailList = []
    },

    checkVGAReceiverInfo () {
      if (this.order.receiverAddress !== '') this.isReceiverInfo.address = true
      else this.isReceiverInfo.address = false

      if (this.order.receiverPostcode !== '') this.isReceiverInfo.postcode = true
      else this.isReceiverInfo.postcode = false

      if (this.order.receiverCity !== '') this.isReceiverInfo.city = true
      else this.isReceiverInfo.city = false

      if (this.order.receiverProvince !== '') this.isReceiverInfo.province = true
      else this.isReceiverInfo.province = false

      if (this.order.receiverCountry !== '') this.isReceiverInfo.country = true
      else this.isReceiverInfo.country = false
    },

    setReceiverInfo (company) {
      this.order.receiverAddress = company.address
      this.order.receiverPostcode = company.postcode
      this.order.receiverCity = company.city
      this.order.receiverProvince = company.province
      this.order.receiverCountry = company.country
      this.order.receiverName = company.name
      this.order.receiverPhone = company.phone
      this.order.receiverFax = company.fax
      this.order.receiverContact = company.contact
      this.order.receiverPlaceId = company.placeId !== undefined ? company.placeId : this.order.receiverPlaceId
      this.order.receiverLat = company.lat !== undefined ? company.lat : this.order.receiverLat
      this.order.receiverLong = company.long !== undefined ? company.long : this.order.receiverLong
    },
    // Receiver End

    /** Save addresses to the addressbook */
    saveToAddressbook (order) {
      if (this.pickupSave) {
        var savedPickup = {
          'address': order.transmitterAddress,
          'city': order.transmitterCity,
          'contact': order.transmitterContact,
          'fax': order.transmitterFax,
          'name': order.transmitterName,
          // 'receptionEmail': order.transmitterEmail,
          'emailList': order.transmitterEmailList,
          'postcode': order.transmitterPostcode,
          'country': order.transmitterCountry,
          'province': order.transmitterProvince,
          'phone': order.transmitterPhone,
          'placeId': order.transmitterPlaceId,
          'lat': order.transmitterLat,
          'long': order.transmitterLong
        }

        let transmitterPlaceId = ''

        if (order.transmitterPlaceId) {
          transmitterPlaceId = order.transmitterPlaceId
          let formattedName = this.removeInvalidChars(order.transmitterName)

          db.ref('database/transporter/' + this.companyUID + '/carnet')
          .child(transmitterPlaceId + '-_name_-' + formattedName)
          .set(savedPickup)
        } else db.ref('database/transporter/' + this.companyUID + '/carnet').push().set(savedPickup)
      }

      if (this.deliverySave) {
        var savedDelivery = {
          'address': order.receiverAddress,
          'city': order.receiverCity,
          'contact': order.receiverContact,
          'fax': order.receiverFax,
          'name': order.receiverName,
          // 'receptionEmail': order.receiverEmail,
          'postcode': order.receiverPostcode,
          'country': order.receiverCountry,
          'province': order.receiverProvince,
          'phone': order.receiverPhone,
          'placeId': order.receiverPlaceId,
          'lat': order.receiverLat,
          'long': order.receiverLong
        }

        let receiverPlaceId = ''

        if (order.receiverPlaceId) {
          receiverPlaceId = order.receiverPlaceId
          let formattedName = this.removeInvalidChars(order.receiverName)

          db.ref('database/transporter/' + this.companyUID + '/carnet')
          .child(receiverPlaceId + '-_name_-' + formattedName)
          .set(savedDelivery)
        } else db.ref('database/transporter/' + this.companyUID + '/carnet').push().set(savedDelivery)
      }
    },

    removeInvalidChars (text) {
      text = text.replace('.', '')
      text = text.replace('$', '')
      text = text.replace('#', '')
      text = text.replace('[', '')
      text = text.replace(']', '')
      text = text.replace('/', '')
      return text
    },

    /** Finds the company in the appropriate list and then sets the info */
    onCompanyNameSelect (companyName, locType) {
      if (!companyName) return

      if (locType === this.baseStr.transmitter) {
        let company = this.arrOfTransmitterPlaces.find(company => company.info.name === companyName)
        this.setTransmitterInfo(company.info)
      } else if (locType === this.baseStr.receiver) {
        let company = this.arrOfReceiverPlaces.find(company => company.info.name === companyName)
        this.setReceiverInfo(company.info)
      }
    },

    /**
     * The @placeId check is used to check if the address has been saved in the address book before
     * If it has been saved, get the whole list of addressbook
     *  */
    async getAddressbook (placeId) {
      if (!placeId) return
      let addressBook = {}

      await db.ref('database')
      .child('transporter')
      .child(this.companyUID)
      .child('carnet')
      .once('value').then((snap) => {
        addressBook = snap.val()
      })

      return addressBook
    },

    /** From the addressbook, get the list of name of companies that have the same @placeId */
    getCommonPlaces (addressBook, placeId) {
      let arrCommonPlaces = []

      for (const key in addressBook) {
        if (Object.hasOwnProperty.call(addressBook, key)) {
          const place = addressBook[key]

          let placeSplit = key.split('-_name_-')
          if (placeSplit[0] === placeId) {
            arrCommonPlaces.push({
              info: place,
              name: place.name
            })
          }
        }
      }

      return arrCommonPlaces
    },

    setAndSearch: function (event, section) {
      if (section === 'pickup') {
        this.$refs.AutocompleteSearchPickup.clear()

        this.datalist.pickup = event.value
        this.datalist.pickupUid = event.key
        if (event.key !== null) {
          db.ref('users/dealersList/' + this.datalist.pickupUid).once('value').then((snap) => {
            if (snap.val()) {
              this.order.transmitterName = snap.val().name
              this.order.transmitterAddress = snap.val().address
              this.order.transmitterCity = snap.val().city
              this.order.transmitterPostcode = snap.val().postcode
              this.order.transmitterPhone = snap.val().phone
              this.order.transmitterEmail = snap.val().receptionEmail || ''
              this.order.transmitterFax = snap.val().fax
              this.order.transmitterProvince = snap.val().province
              this.order.transmitterCountry = snap.val().country
              this.order.transmitterPlaceId = snap.val().placeId
              this.order.transmitterLat = snap.val().long
              this.order.transmitterLong = snap.val().lat
              // console.log(snap.val())
            }
            // this.order.transmitterContact = snap.val().contact
          }).catch(function (error) {
            console.log(error)
          })
          this.addressbook.forEach((entry) => {
            if (entry['key'] === this.datalist.pickupUid) {
              this.order.transmitterName = entry.name
              this.order.transmitterAddress = entry.address
              this.order.transmitterCity = entry.city
              this.order.transmitterPostcode = entry.postcode
              this.order.transmitterPhone = entry.phone
              this.order.transmitterEmail = entry.receptionEmail || ''
              this.order.transmitterFax = entry.fax
              this.order.transmitterProvince = entry.province
              this.order.transmitterCountry = entry.country
              this.order.transmitterPlaceId = entry.placeId
              this.order.transmitterLat = entry.long
              this.order.transmitterLong = entry.lat
            }
          })
        }
      }

      if (section === 'delivery') {
        this.$refs.AutocompleteSearchDelivery.clear()
        this.datalist.delivery = event.value
        this.datalist.deliveryUid = event.key
        if (event.key !== null) {
          db.ref('users/dealersList/' + this.datalist.deliveryUid).once('value').then((snap) => {
            if (snap.val()) {
              this.order.receiverName = snap.val().name
              this.order.receiverAddress = snap.val().address
              this.order.receiverCity = snap.val().city
              this.order.receiverPostcode = snap.val().postcode
              this.order.receiverPhone = snap.val().phone
              this.order.receiverEmail = snap.val().receptionEmail || ''
              this.order.receiverFax = snap.val().fax
              this.order.receiverProvince = snap.val().province
              this.order.receiverCountry = snap.val().country
              this.order.receiverPlaceId = snap.val().placeId
              this.order.receiverLat = snap.val().long
              this.order.receiverLong = snap.val().lat
              if (this.billingSame) this.order.sageID = snap.val().sageID
              this.backup.sageIDDelivery = snap.val().sageID
              this.onInputBillingSame()
            }
            // this.order.transmitterContact = snap.val().contact
          }).catch(function (error) {
            console.log(error)
          })
          this.addressbook.forEach((entry) => {
            if (entry['key'] === this.datalist.deliveryUid) {
              this.order.receiverName = entry.name
              this.order.receiverAddress = entry.address
              this.order.receiverCity = entry.city
              this.order.receiverPostcode = entry.postcode
              this.order.receiverPhone = entry.phone
              this.order.receiverEmail = entry.receptionEmail || ''
              this.order.receiverFax = entry.fax
              this.order.receiverProvince = entry.province
              this.order.receiverCountry = entry.country
              this.order.receiverPlaceId = entry.placeId
              this.order.receiverLat = entry.long
              this.order.receiverLong = entry.lat
              if (this.billingSame) this.order.sageID = entry.sageID
              this.backup.sageIDDelivery = entry.sageID
              this.onInputBillingSame()
            }
          })
        }
      }

      if (section === 'billing') {
        this.datalist.billing = event.value
        this.datalist.billingUid = event.key
        if (event.key !== null) {
          db.ref('users/dealersList/' + this.datalist.billingUid).once('value').then((snap) => {
            if (snap.val()) {
              this.order.payerName = snap.val().name
              this.order.payerAddress = snap.val().address
              this.order.payerCity = snap.val().city
              this.order.payerPostcode = snap.val().postcode
              this.order.payerPhone = snap.val().phone
              this.order.payerEmail = snap.val().receptionEmail || ''
              this.order.payerFax = snap.val().fax
              this.order.payerProvince = snap.val().province
              this.order.payerCountry = snap.val().country
              this.order.sageID = snap.val().sageID
            }
            // this.order.transmitterContact = snap.val().contact
          }).catch(function (error) {
            console.log(error)
          })
          this.addressbook.forEach((entry) => {
            if (entry['key'] === this.datalist.billingUid) {
              this.order.payerName = entry.name
              this.order.payerAddress = entry.address
              this.order.payerCity = entry.city
              this.order.payerPostcode = entry.postcode
              this.order.payerPhone = entry.phone
              this.order.payerEmail = entry.receptionEmail || ''
              this.order.payerFax = entry.fax
              this.order.payerProvince = entry.province
              this.order.payerCountry = entry.country
              this.order.sageID = entry.sageID
            }
          })
        }
      }
    },

    // Button: Same as pickup
    // Copies pickup info as billing info
    onInputBillingSame: function () {
      if (this.billingSame) {
        this.order.payerAddress = this.order.receiverAddress
        this.order.payerCity = this.order.receiverCity
        this.order.payerContact = this.order.receiverContact
        this.order.payerFax = this.order.receiverFax
        this.order.payerName = this.order.receiverName
        this.order.payerPhone = this.order.receiverPhone
        this.order.payerEmail = this.order.receiverEmail
        this.order.payerPostcode = this.order.receiverPostcode
        this.order.payerProvince = this.order.receiverProvince
        this.order.payerCountry = this.order.receiverCountry
      }
    },

    onResize: _.debounce(function () {
      this.isScreenSmall = window.innerWidth < 600
    }, 50)
  },

  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },

  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },

  computed: {
    companyUID () {
      return this.$store.state.authorization.company
    },
    sageIDonly () {
      return this.addressbook.filter(customer => customer.sageID)
    },

    sageOneCheck () {
      return ((this.$store.state.userInfo.isSageOne && this.order.sageID !== '' && this.order.sageID !== undefined) || !this.$store.state.userInfo.isSageOne)
    },

    isSageOne () {
      return this.$store.state.userInfo.isSageOne
    },

    formCompleted: function () {
      var order = this.order
      return (
        this.vehicles.length !== 0 &&
        order.receiverName !== '' &&
        order.receiverAddress !== '' &&
        order.receiverCountry !== '' &&
        order.receiverCity !== '' &&
        order.receiverPostcode !== '' &&
        order.receiverProvince !== '' &&
        order.payerName !== '' &&
        order.payerAddress !== '' &&
        order.payerCountry !== '' &&
        order.payerCity !== '' &&
        order.payerPostcode !== '' &&
        order.payerProvince !== '' &&
        order.transmitterName !== '' &&
        order.transmitterAddress !== '' &&
        order.transmitterCountry !== '' &&
        order.transmitterCity !== '' &&
        order.transmitterPostcode !== '' &&
        order.transmitterProvince !== '' &&
        ((this.isSageOne && order.price !== '') || !this.isSageOne))
    }
  },

  watch: {
    processing: function () {
      this.filteredSearchMethod()
    },

    billingSame: function (val) {
      var order = this.order
      if (!val) {
        order.payerAddress = ''
        order.payerCity = ''
        order.payerContact = ''
        order.payerFax = ''
        order.payerName = ''
        order.payerPhone = ''
        order.payerEmail = ''
        order.payerPostcode = ''
        order.payerProvince = ''
        order.payerCountry = ''
        order.sageID = ''
      } else {
        order.payerAddress = order.receiverAddress
        order.payerCity = order.receiverCity
        order.payerContact = order.receiverContact
        order.payerFax = order.receiverFax
        order.payerName = order.receiverName
        order.payerPhone = order.receiverPhone
        order.payerEmail = order.receiverEmail
        order.payerPostcode = order.receiverPostcode
        order.payerProvince = order.receiverProvince
        order.payerCountry = order.receiverCountry
        order.sageID = this.backup.sageIDDelivery || ''
        this.datalist.billing = ''
        this.datalist.billingUid = ''
      }
    },

    '$route.query': function (val) {
      // console.log(val)
      this.filteredSearchMethod()
    }
  }
}
</script>

<style scoped>
.orderInfoContainer {
  display: flex;
  width: 100%;
  flex-direction: row;
}

/* Mobile */
.orderInfoContainer--Mobile {
  display: flex;
  width: 100%;
  flex-direction: column;
}

.orderColumn {
  width: 100%;
  justify-content: space-between;
}

.input--missing {
  border: rgb(252, 30, 30) solid 1px;
  border-radius: 4px;
  background-color: rgb(214, 214, 214);
}
.flex-row {
  display: flex;
  flex-flow: row;
}
.hrLine {
  border: dotted grey 1px;
  margin-top: 1.15rem;
}
</style>
